const number = {
  currency: (value) => {
    return value.toLocaleString('ko-KR')
  }
}

export default number
